import { AutocodeInfoResponse, AutocodeResponse, Driver, KbmReponse } from "@/services/index.defs";
import { InfoService } from "@/services/InfoService";
import { ApiResponse } from "../services/index.defs";
import { GaHelper } from "@/core/helpers/ga";
export class InfoModule {
    isLoading: boolean = false;
    driverKbm: { driver: Driver; kbm: number }[] = [];
}

export default {
    namespaced: true as true,
    state: new InfoModule(),

    mutations: {},
    actions: {
        async getAutoFullInfo({ state, commit, dispatch }, request: { licensePlate: string; token: string }): Promise<ApiResponse<AutocodeInfoResponse>> {
            state.isLoading = true;
            const res = await InfoService.getAutoCodeInfo(request, { headers: { UserId: GaHelper.userId } });
            if (res?.success) {
                if (res.data?.report) {
                    const report = res.data.report;
                    const dopPromises = [];
                    if (report?.markId && report.markId !== "0") {
                        dopPromises.push(dispatch("dicti/getMapModels", report.markId, { root: true }));
                    }
                    if (report?.modelId && report.modelId !== "0") {
                        dopPromises.push(dispatch("dicti/getModifications", report.modelId, { root: true }));
                    }

                    await Promise.all(dopPromises);
                    commit("insurance/setAutoCodeResponse", report, { root: true });
                }
            }
            state.isLoading = false;
            return res;
        },
        async getAuto({ state, commit, dispatch }, licensePlate: string): Promise<ApiResponse<AutocodeResponse>> {
            state.isLoading = true;
            const res = await InfoService.getAuto({ licensePlate: licensePlate });
            if (res.success) {
                const dopPromises = [];
                if (res.data.markId) {
                    dopPromises.push(dispatch("dicti/getMapModels", res.data.markId, { root: true }));
                }
                if (res.data.modelId) {
                    dopPromises.push(dispatch("dicti/getModifications", res.data.modelId, { root: true }));
                }
                await Promise.all(dopPromises);
                commit("insurance/setAutoCodeResponse", res.data, { root: true });
            }
            state.isLoading = false;
            return res;
        },
        async loadDriversKbm({ state, commit, dispatch }, drivers: Driver[]) {
            state.driverKbm = [];
            const kbmPromises = [];
            for (let i = 0; i < drivers.length; i++) {
                const driver = drivers[i];
                const promise = new Promise(async (resolve) => {
                    // резолвим объект с драйвером, т.к. он понадобится нам далее
                    resolve({
                        driver: driver,
                        kbm: await dispatch("loadKbm", driver),
                    });
                });
                kbmPromises.push(promise); //) as ApiResponse<KbmReponse>;
            }
            const kbmResults = await Promise.allSettled(kbmPromises);
            kbmResults.forEach(
                (
                    result: PromiseSettledResult<{
                        driver: Driver;
                        kbm: ApiResponse<KbmReponse>;
                    }> // такой тип для того чтобы учесть драйвера из промиса выше
                ) => {
                    if (result.status === "fulfilled" && result.value.kbm.success)
                        state.driverKbm.push({
                            driver: result.value.driver,
                            kbm: result.value.kbm.data.value,
                        });
                }
            );
        },
        async loadKbm({ state, commit }, driver: Driver): Promise<ApiResponse<KbmReponse>> {
            const res = await InfoService.getKbm({ body: driver });
            return res;
        },
    },
    getters: {},
};
